import styled from 'styled-components';
import { rem } from 'polished';
import screen from 'superior-mq';
import { bp } from 'Styles/helpers';

const HomeH3 = styled.h3`
  font-size: ${rem(130)};
  text-align: ${props => props.align || 'center'};

  ${screen.below(bp.laptop, `
    font-size: ${rem(80)};
  `)}

  ${screen.below(bp.mobile, `
    font-size: ${rem(65)};
  `)}
`;

export default HomeH3;
